<template>
  <module-box
    type="weapon-info"
    :mode="mode"
    :moduleData="moduleData"
    showSetup
    @onAdd="handleAddModule"
    @onSetup="handleOpenModuleSetupPanel"
    @onDelete="handleDeleteModule"
    @onMore="handleMore"
  >
    <div class="weapon-info" :class="{ 'is-edit': mode === 'edit' }">
      <module-title :mode="mode" :title="moduleData.title" @onChange="handleTitleChange"></module-title>
      <div class="container">
        <div class="base-info">
          <div class="image-info" v-if="moduleData.isShowIcon">
            <resize-box
              :width="moduleData.iconSize ? moduleData.iconSize.width : '312px'"
              :height="moduleData.iconSize ? moduleData.iconSize.height : '154px'"
              :active="mode == 'edit' ? ['r', 'rb', 'b'] : []"
              @resize:end="handleResizeEnd"
            >
              <img v-if="moduleData.icon" :src="moduleData.icon" class="preview-image" />
              <upload-image v-else-if="mode === 'edit'" @onImageUploaded="handelIconUploaded"></upload-image>
              <div class="edit-btns" v-if="moduleData.icon && mode === 'edit'">
                <button class="btn edit-btn">
                  <upload-image type="edit" :data="moduleData.icon" @onImageUploaded="handelIconUploaded">
                    <i class="wiki-icon wiki-editable-edit"></i>
                  </upload-image>
                </button>
              </div>
            </resize-box>
          </div>
          <div class="text-info">
            <div class="label" v-if="moduleData.isShowLabel">
              <text-box
                type="editor"
                :mode="mode"
                :image-style="{ height: '22px' }"
                :value="moduleData.label || '标签'"
                @onChange="handleLabelChange"
              >
                {{ moduleData.label || "标签" }}
              </text-box>
            </div>
            <div class="name" v-if="moduleData.isShowName">
              <text-box
                type="editor"
                :mode="mode"
                :image-style="{ height: '22px' }"
                :value="moduleData.name || '名称'"
                @onChange="handleNameChange"
              >
                {{ moduleData.name || "名称" }}
              </text-box>
            </div>
            <div class="desc" v-if="moduleData.isShowDesc">
              <text-box
                type="editor"
                :mode="mode"
                :image-style="{ height: '22px' }"
                :value="moduleData.desc || '描述'"
                @onChange="handleDescChange"
              >
                {{ moduleData.desc || "描述" }}
              </text-box>
            </div>
          </div>
        </div>
        <div class="table-info" v-if="moduleData.isShowTable">
          <template v-if="moduleData.tableList && moduleData.tableList.length > 0">
            <editable-table
              v-for="(tableData, index) in moduleData.tableList"
              :key="tableData.key"
              :mode="mode"
              :data="tableData"
              @onAdd="handleAddTableData(index)"
              @onDelete="handleTableDataDelete(index)"
              @onChange="value => handleTableDataChange(index, value)"
            ></editable-table>
          </template>
          <template v-else-if="mode == 'edit'">
            <button class="add-btn" @click.stop="handleAddTableData(0)">
              <i class="icon wiki-editable-add"></i>
            </button>
          </template>
        </div>
        <div class="skill-info" v-if="moduleData.isShowSkill">
          <!-- <template v-if="Object.keys(moduleData.skillData).length > 0">
            <skill-info
              :mode="mode"
              size="small"
              :data="moduleData.skillData"
              @onAdd="handleAddSkillInfo"
              @onDelete="handleDeleteSkillInfo"
              @onChange="data => hanldeSkillDataChange(data)"
            ></skill-info>
          </template>
          <template v-else-if="mode == 'edit'">
            <button class="add-btn" @click.stop="handleAddSkillInfo">
              <i class="icon wiki-editable-add"></i>
            </button>
          </template> -->
          <draggable
            v-model="skillList"
            :animation="200"
            :group="'skillInfoList'"
            :disabled="mode !== 'edit'"
            :ghostClass="'ghost'"
            :handle="'.edit-drag'"
            @start="dragSkill = true"
            @end="dragSkill = false"
            @change="handleSortSkill"
          >
            <template v-if="skillList.length > 0">
              <div class="skill-item" v-for="(data, index) in skillList" :key="data.key">
                <info-item
                  :mode="mode"
                  :data="data"
                  size="small"
                  @onAdd="handleAddSkillInfo(index)"
                  @onDelete="handleDeleteSkillInfo(index)"
                  @onChange="data => hanldeSkillDataChange(index, data)"
                ></info-item>
              </div>
            </template>
            <template v-else-if="mode == 'edit'">
              <button class="add-btn" @click.stop="handleAddSkillInfo(0)">
                <i class="icon wiki-editable-add"></i>
              </button>
            </template>
          </draggable>
        </div>
      </div>
    </div>
    <!-- 设置 -->
    <setup-panel v-if="mode === 'edit'" ref="setupPanel" :data="moduleData" @onChange="handleChangeData"></setup-panel>
  </module-box>
</template>

<script>
import draggable from "vuedraggable";
// components
import ModuleBox from "../../components/ModuleBox";
import TextBox from "../../components/TextBox";
import UploadImage from "../../components/UploadImage";
import EditableTable from "../../components/EditableTable";
import InfoItem from "../SkillInfo/components/InfoItem";
import ModuleTitle from "../../components/ModuleTitle";
import ResizeBox from "../../components/ResizeBox";
import SetupPanel from "./SetupPanel";

export default {
  name: "WeaponInfo",
  components: {
    draggable,
    ModuleBox,
    TextBox,
    UploadImage,
    EditableTable,
    InfoItem,
    ModuleTitle,
    ResizeBox,
    SetupPanel
  },
  props: {
    mode: String,
    moduleData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      skillList: [],
      dragSkill: false
    };
  },
  watch: {
    moduleData: {
      handler(val) {
        this.skillList = Array.isArray(val.skillData) ? val.skillData : [val.skillData];
      },
      immediate: true
    }
  },
  mounted() {},

  methods: {
    handleAddModule() {
      this.$emit("onAdd");
    },
    // 模块更多操作
    handleMore(command, data) {
      if (command === "copy") {
        const moduleData = JSON.parse(JSON.stringify(this.moduleData));
        this.$emit("onCopy", moduleData);
      }
    },
    // 模块设置
    handleOpenModuleSetupPanel() {
      this.$refs.setupPanel.open();
    },
    handleChangeData(data) {
      this.$emit("onChange", data);
    },
    // 模块删除
    handleDeleteModule() {
      this.$emit("onDelete");
    },
    handleTitleChange(title) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.title = title;
      this.$emit("onChange", moduleData);
    },
    handleResizeEnd({ width, height }) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.iconSize = {
        width: width || "312px",
        height: height || "154px"
      };
      this.$emit("onChange", moduleData);
    },
    handelIconUploaded(imgList) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.icon = imgList[0];
      this.$emit("onChange", moduleData);
    },
    handleLabelChange(label) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.label = label;
      this.$emit("onChange", moduleData);
    },
    handleNameChange(name) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.name = name;
      this.$emit("onChange", moduleData);
    },
    handleDescChange(desc) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.desc = desc;
      this.$emit("onChange", moduleData);
    },
    handleAddTableData(index = 0) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      if (!moduleData.tableList) {
        moduleData.tableList = [];
      }
      moduleData.tableList.splice(index + 1, 0, {
        key: Math.random().toString(16),
        title: "表格标题",
        colStyle: [{ align: "left" }],
        head: [""],
        body: [[""]]
      });
      this.$emit("onChange", moduleData);
    },
    handleTableDataDelete(index = 0) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.tableList.splice(index, 1);
      this.$emit("onChange", moduleData);
    },
    handleTableDataChange(index, tableData) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.tableList.splice(index, 1, tableData);
      this.$emit("onChange", moduleData);
    },
    handleAddSkillInfo(index = 0) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      const item = {
        key: Math.random().toString(16),
        isShowIcon: true,
        isShowName: true,
        isShowDesc: true,
        isShowMore: true,
        icon: "",
        name: "",
        label: "",
        desc: "",
        moreInfo: ""
      };
      if (!Array.isArray(moduleData.skillData)) {
        moduleData.skillData = [moduleData.skillData];
      }
      moduleData.skillData.splice(index + 1, 0, item);
      this.$emit("onChange", moduleData);
    },
    handleDeleteSkillInfo(index = 0) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      if (!Array.isArray(moduleData.skillData)) {
        moduleData.skillData = [moduleData.skillData];
      }
      moduleData.skillData.splice(index, 1);
      this.$emit("onChange", moduleData);
    },
    hanldeSkillDataChange(index, data) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      if (!Array.isArray(moduleData.skillData)) {
        moduleData.skillData = [moduleData.skillData];
      }
      moduleData.skillData.splice(index, 1, data);
      this.$emit("onChange", moduleData);
    },
    handleSortSkill() {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));

      moduleData.skillData = this.skillList;
      this.$emit("onChange", moduleData);
    }
  }
};
</script>

<style lang="less" scoped>
.weapon-info {
  width: 100%;
  &.is-edit {
    .image-info {
      /deep/ .resizable-component {
        &:hover {
          background-color: #c7ccd5;
          outline: #c7ccd5;
          outline-style: solid;
          outline-width: 3px;
          cursor: pointer;
          .edit-btns {
            display: inline-flex;
          }
        }
      }
    }
  }
  .container {
    padding: 20px 24px;
  }
  .base-info {
    width: 100%;
    display: flex;
    gap: 20px;
    align-items: center;
    .image-info {
      display: inline-block;
      // background: rgba(19, 29, 47, 0.16);
      border-radius: 8px;
      border: 1px solid rgba(19, 29, 47, 0.16);
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }

      .edit-btns {
        display: none;
        position: absolute;
        height: 20px;
        right: 0px;
        top: -20px;
        .btn {
          width: 20px;
          height: 20px;
          color: #ffffff;
          border-radius: 4px;
          margin-left: 3px;
          border: none;
          vertical-align: middle;
          line-height: 20px;
          text-align: center;
          overflow: hidden;
          &:hover {
            opacity: 0.9;
          }
          .wiki-icon {
            display: inline-block;
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .text-info {
      width: 100%;
      .label {
        font-size: 14px;
        font-weight: bold;
        color: #707478;
        line-height: 20px;
        margin-bottom: 8px;
      }
      .name {
        font-size: 24px;
        font-weight: bold;
        color: #212121;
        line-height: 33px;
        margin-bottom: 9px;
      }
      .desc {
        font-size: 14px;
        font-weight: 400;
        color: #373737;
        line-height: 22px;
      }
    }
  }
  .table-info {
    margin-top: 12px;
  }
  .skill-info {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid rgba(0, 0, 0, 0.11);
    /deep/ .skill-item {
      margin-bottom: 12px;
      &:last-child {
        .skill-main {
          border-bottom: none;
        }
      }
    }
  }
}
.add-btn {
  width: 20px;
  height: 20px;
  color: #ffffff;
  border-radius: 4px;
  margin-left: 3px;
  border: none;
  vertical-align: middle;
  line-height: 20px;
  text-align: center;
  &:hover {
    opacity: 0.9;
  }
  .icon {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
}
</style>
